import React, { useContext, useEffect } from "react";
import { Form } from "antd";

import { VolunteeringRecords } from "./volunteering-records";
import { FormContainer } from "../../../../../../shared";
import { fieldValidationMessages } from "../../../../../../../utils";
import {
  NewExpertContext
} from "../../../../../../../contexts/experts/new/context";

const { Item } = Form;

export const VolunteeringForm = ({ editable = true }) => {
  const {
    onFormFieldsChange,
    form,
    data = {}
  } = useContext(NewExpertContext);

  const { user = {} } = data;
  const {
    volunteerings = []
  } = user?.expertProfile?.professionalExperience || {};

  useEffect(() => {
    form.setFieldsValue({
      volunteerings
    });
  }, [data]);

  return (
    <FormContainer>
      <Form
        validateMessages={fieldValidationMessages}
        onFieldsChange={onFormFieldsChange}
        form={form}
        layout="vertical">
        <Item
          name="volunteerings"
          trigger="onSave"
          valuePropName="volunteerings"
          label={editable && "Voluntariados"}
          initialValue={volunteerings}
          rules={[{ required: true }]}>
          <VolunteeringRecords editable={editable} />
        </Item>
      </Form>
    </FormContainer>
  );
};
